import { render, staticRenderFns } from "./NuevaCotizacion.vue?vue&type=template&id=b3cf1552&scoped=true&"
import script from "./NuevaCotizacion.vue?vue&type=script&lang=js&"
export * from "./NuevaCotizacion.vue?vue&type=script&lang=js&"
import style0 from "./NuevaCotizacion.vue?vue&type=style&index=0&id=b3cf1552&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cf1552",
  null
  
)

export default component.exports